module.exports = __webpack_public_path__ + "images/emoji/sunflower.a608a48a715ef4c5fa93.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sunflower.png
// module id = FlV8
// module chunks = 24